module.exports = __webpack_public_path__ + "images/conversation.svg?ced783d0fdbb5b78ff9915fb806904fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/conversation.svg
// module id = 169
// module chunks = 0